import React, {Component} from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';

class FormGroupSelectMany extends Component {

    _changeCheckedItems = (option) => {
        let newCheckedItems = {...this.props.checkedItems};
        if( _.has(this.props.checkedItems, option.key)){
            delete newCheckedItems[option.key];
        }
        else {
            newCheckedItems = {...newCheckedItems, [option.key]: option.value};
        }
        this.props.handleChange(this.props.name, newCheckedItems);
    };

    render() {
        return(
            <div className={'form-group'}>
                <div className={this.props.leftClassName}>
                    <label className={"control-label.text-left formGroupSelectInput-label" +
                    (this.props.required?' inputRequired':'')
                    }>
                        {this.props.label}
                    </label>
                </div>
                <div className={this.props.centerClassName + ' ' + 'formGroupSelectInput-select-wrapper'}>
                    <ul className={'formGroupSelectMultiple-list-wrapper'}>
                        {
                            this.props.options.map( option => {
                                return (
                                    <li key={option.key} className={'formGroupSelectMultiple-select-option-wrapper'}>
                                        <input
                                            name={this.props.name}
                                            checked={_.has(this.props.checkedItems, option.key)}
                                            id={this.props.name + ' ' + option.key}
                                            type="checkbox"
                                            className={"formGroupSelectMultiple-check_box"}
                                            onChange={() => this._changeCheckedItems(option)}
                                        />
                                        <label
                                            className="formGroupSelectMultiple-select-option"
                                            htmlFor={this.props.name + ' ' + option.key}
                                        >
                                            {option.name}
                                        </label>
                                    </li>
                                )
                            })
                        }
                    </ul>
                </div>
                <div className={this.props.rightClassName}>
                </div>
            </div>
        )
    }
}

FormGroupSelectMany.propTypes = {
    label: PropTypes.string,
    leftClassName: PropTypes.string,
    centerClassName: PropTypes.string,
    rightClassName: PropTypes.string,
    name: PropTypes.string.isRequired, //must be unique if multiple same FormGroupSelectMany components exist side by side
    options: PropTypes.array.isRequired,
    handleChange: PropTypes.func.isRequired,
    checkedItems: PropTypes.object.isRequired, // object with checked items by id. for example {4: {name:'321'}}

};

export default FormGroupSelectMany;